import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import { Auth, retrieveTokenDev } from "../utils/auth/Auth";
import { ContextProvider } from "./ContextProvider";

const PrivateRoute = () => {
    const userName = "public-user";

    const [token, setToken] = useState(null);

    /**
     * username is strictly a development var
     */
    useEffect(() => {
        if (userName) {
            retrieveTokenDev(0, userName).then((response) => {
                setToken(response);
            });
        }
    }, [userName]);

    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    return token ? (
        <ContextProvider>
            <Outlet />
            <Auth />
        </ContextProvider>
    ) : (
        <Auth />
    );
};

export default PrivateRoute;
